import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  Container,
  CardContent,
  Button,
  Grid,
  Divider,
  TextField,
  Stack,
  ListItemText,
  ListItemIcon,
  List,
  ListItem,
  Table,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import { toast } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import ToastApp from "../../../ToastApp";
import Chip from "@mui/material/Chip";
import { DataGrid, GridToolbar, GridColDef } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/Edit";
import ChevronRightIcon from "@mui/icons-material/Edit";
// import TreeView from '@mui/lab/TreeView';
// import TreeItem from '@mui/lab/TreeItem';
import { TreeView } from "@mui/x-tree-view/TreeView";

import { TreeItem, treeItemClasses } from "@mui/x-tree-view/TreeItem";
//import { TreeView, TreeItem } from '@mui/lab';
import { FormControlLabel, Checkbox } from "@mui/material";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { RichTreeView } from "@mui/x-tree-view";
import { styled } from "@mui/material/styles";
import { JSX } from "react/jsx-runtime";
import TableContainer from "@mui/material/TableContainer";
import { row } from "@syncfusion/ej2-react-grids";
import api from "../../../utils/Url";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
// const treedata = [
//   {
//     id: 1,
//     name: 'Parent 1',
//     children: [
//       { id: 2, name: 'Child 1' },
//       { id: 3, name: 'Child 2' },
//     ],
//   },
//   {
//     id: 4,
//     name: 'Parent 2',
//     children: [
//       { id: 5, name: 'Child 3' },
//       { id: 6, name: 'Child 4' },
//     ],
//   },
// ];

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);
  const back = useNavigate();
  let navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [toaster, setToaster] = useState(false);
  const requiredFields = ["dept_id", "designation_name"];
  const [option, setOption] = useState([
    { value: "-1", label: t("text.selectParntLoc") },
  ]);
  const [childOption, setChildOption] = useState([
    { value: "-1", label: t("text.selectLoc"), aliasName: "", from: 0, to: 0 },
  ]);
  const [tabledata, setTabledata] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [columns, setColumns] = useState<any>([]);
  const [treedata, setTreedata] = useState<any>([]);
  const [parentId, setParentId] = useState<any>(0);
  const [EditId, setEditId] = useState(-1);
  const [filter, setFilter] = useState("");
  const [expandedNodes, setExpandedNodes] = useState([]);

  const handleFilterChange = (event: any) => {
    setFilter(event.target.value);
  };

  const handleNodeToggle = (itemId: any) => () => {
    setExpandedNodes((prevExpandedNodes: any) => {
      const isExpanded = prevExpandedNodes.includes(itemId);
      return isExpanded
        ? prevExpandedNodes.filter((id: any) => id !== itemId)
        : [...prevExpandedNodes, itemId];
    });
  };

  const validationSchema = Yup.object({
    designation_name: Yup.string().test(
      "required",
      t("text.reqdeadditem"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    dept_id: Yup.string().test(
      "required",
      t("text.reqdAlias"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
  });

  useEffect(() => {
    getParentlocationitem();
    // getChildlocationitem();
    getMappedLocationData();
    fetchMappedLocationData();
  }, []);
  const getParentlocationitem = () => {
    const collectData = {
      id: -1,
      locationObjectId: -1,
      parentId: -1,
    };
    api
      .post( `LocationItems/GetLocationItems`, collectData)
      .then((res) => {
        const arr: any = [];
        console.log("result" + JSON.stringify(res.data.data));
var childdata=res.data.data;
        for (let index = 0; index < res.data.data.length; index++) {
            if(res.data.data[index]["parentId"]==0){
                
                arr.push({
                    label: res.data.data[index]["locationObjectItem"],
                    value: res.data.data[index]["id"],
                  });
            } else {
                tempname="";
             var  locationObjectItem =  findParentById(childdata,res.data.data[index]["parentId"])
             //console.log("locationObjectItem",locationObjectItem);
             
             
                arr.push({
                    label: locationObjectItem+""+res.data.data[index]["locationObjectItem"],
                    value: res.data.data[index]["id"],
                  });
            }
           
        }
        setOption(arr);
      });
  };
  var tempname="";
 const findParentById = (data:any,parentId:any) => {
    var childdata = data.find((item: { id: any; }) => item.id === parentId);
    //console.log("locationObjectItem",childdata.locationObjectItem)
   
   console.log('tempname',tempname);
     if(childdata.parentId>0){
        tempname = childdata.locationObjectItem+"->"+tempname;
        findParentById(data,childdata.parentId)
     } 
     else {
        tempname = childdata.locationObjectItem+"->"+tempname;
     }
       return tempname;
  };
  const getChildlocationitem = (id: any) => {
    const collectData = {
      id: -1,
      locationObjectId: -1,
      parentId: id,
    };
    api
      .post( `LocationItems/GetLocationItems`, collectData)
      .then((res) => {
        const arr: any = [];
        console.log("result" + JSON.stringify(res.data.data));

        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["locationObjectItem"],
            value: res.data.data[index]["id"],
          });
        }
        setChildOption(arr);
      });
  };

  const getMappedLocationData = () => {
    const collectData = {
      id: -1,
    };
    api
      .post(
         `LocationItems/GetLocationItemsHierarchical`,
        collectData
      )
      .then((res) => {
        const arr: any = [];
        console.log("result" + JSON.stringify(res.data.data));
        if (res.data.data.length > 0) {
          setTreedata(res.data.data);
        }
      });
  };

  const Addmappedlocation = () => {
    const arr: any = [];

    for (let index = 0; index < checked.length; index++) {
      const element = checked[index];
      if (checked[index] > 0) {
        arr.push({
          id: checked[index],
          locationObjectId: 0,
        });
      }
    }
    const collectData = {
      id: EditId,
      childlocation: arr,
    };
    api
      .post(
         `LocationItems/AddUpdateMappedLocationItems`,
        collectData
      )
      .then((response) => {
        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          setChecked([]);
          fetchMappedLocationData();
        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      });
  };

  const AddlocationItem = () => {
    const locationItemstrans: any = [];
    var locationObjectId = formik.values.locationObjectId;
if(selectedOptions?.length>0){
    if (selectedOptions?.length > 1) {
      for (let index = 0; index < selectedOptions.length; index++) {
        const element = selectedOptions[index];
        locationItemstrans.push({
          locationObjectId: selectedOptions[index].value,
          locationObjectItem: selectedOptions[index].label,
          locationAliasItem: selectedOptions[index].aliasName,
          fromNo: selectedOptions[index].from,
          toNo: selectedOptions[index].to,
        });
      }
    } else {
      locationObjectId = selectedOptions[0]?.value;
    }
}
    // console.log("data log", locationItemstrans);

    const collectData = {
      id: -1,
      locationObjectId: locationObjectId,
      parentId: parentId,
      locationObjectItem: formik.values.locationObjectItem,
      inst_Id: formik.values.inst_Id,
      locationAliasItem: formik.values.locationAliasItem,
      fromNo: formik.values.fromNo,
      toNo: formik.values.toNo,
      locationItemstrans: locationItemstrans,
    };

     console.log("data", collectData)
    api
      .post(
         `LocationItems/AddUpdateLocationItems`,
        collectData
      )
      .then((response) => {
        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          setParentId(null);
          formik.resetForm();
          getParentlocationitem();
          fetchMappedLocationData();
        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      });
  };

  const UnmappedlocationItem = () => {
    const arr: any = [];

    for (let index = 0; index < checked.length; index++) {
      const element = checked[index];
      if (checked[index] > 0) {
        arr.push({
          id: checked[index],
          locationObjectId: 0,
        });
      }
    }
    const collectData = {
      id: -1,
      childlocation: arr,
    };
    api
      .post(
        `LocationItems/DeleteMappedLocation`,
        collectData
      )
      .then((response) => {
        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          fetchMappedLocationData();
        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      });
  };

  const formik = useFormik({
    initialValues: {
      id: -1,
      locationObjectId: 0,
      parentId: 0,
      locationObjectItem: "",
      inst_Id: "1",
      locationAliasItem: "",
      fromNo: 0,
      toNo: 0,
      locationItemstrans: [],
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {},
  });

  const mappedEdit = async (value: any) => {
    var location_Path = value["location_Path"];
    var id = value["id"];
    console.log(id);
    setEditId(id);
    console.log(location_Path);
    var asd = location_Path.split("-");
    const newChecked = [{}];
    console.log("newChecked", newChecked);

    setChecked(newChecked);
    asd.forEach((element: any) => {
      newChecked.push(parseInt(element));
      //console.log("element",element)
    });
    setChecked(newChecked);
  };

  const fetchMappedLocationData = async () => {
    try {
      const collectData = {
        id: -1,
         "location": ""
      };
      console.log("collectData", collectData);
      const response = await api.post(
         `LocationItems/GetMappedLocation`,
        collectData
      );
      console.log("result ", response.data.data);
      const data = response.data.data;
      const zonesWithIds = data.map((emp: any, index: any) => ({
        ...emp,
        serialNo: index + 1,
        id: emp.id,
      }));

      setTabledata(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "actions",
            headerClassName: "MuiDataGrid-colCell",
            headerName: t("text.Action"),
            width: 150,

            renderCell: (params) => {
              return [
                <Stack
                  spacing={1}
                  direction="row"
                  sx={{ alignItems: "center", marginTop: "5px" }}
                >
                  {/* {permissionData?.isEdit ? ( */}
                  <EditIcon
                    style={{
                      fontSize: "20px",
                      color: "blue",
                      cursor: "pointer",
                    }}
                    className="cursor-pointer"
                    onClick={() => mappedEdit(params.row)}
                  />
                </Stack>,
              ];
            },
          },

       //   {
        //     field: "serialNo",
        //     headerName: "Sr No.",
        //     flex: 1,
        //     headerClassName: "MuiDataGrid-colCell",
        //   },
        //   {
        //     field: "location_Path",
        //     headerName: "Location Path",
        //     flex: 1,
        //     headerClassName: "MuiDataGrid-colCell",
        //   },
       // {
          //   field: "serialNo",
          //   headerName: "Sr No.",
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
          // {
          //   field: "location_Path",
          //   headerName: "Location Path",
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
         {
            field: "location",
            headerName:t("text.LocationName"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));

  const [checked, setChecked] = useState<any>([]);

  const handleToggle = (id: number) => () => {
    const currentIndex = checked.indexOf(id);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(id);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const renderTree = (nodes: any) => (
    <TreeItem
      key={nodes.id}
      itemId={String(nodes.id)}
      label={
        <div style={{ display: "flex", alignItems: "center" }}>
          <Checkbox
            checked={checked.indexOf(nodes.id) !== -1}
            onChange={handleToggle(nodes.id)}
            onClick={(event:any) => event.stopPropagation()}
          />

          <div style={{ marginLeft: 8 }}>{nodes.locationObjectItem}</div>
        </div>
      }
    >
      {Array.isArray(nodes.childLocI)
        ? nodes.childLocI.map((node: any) => renderTree(node))
        : null}
    </TreeItem>
  );

  // const renderTrees = (nodes: any) => (
  //   <TreeItem
  //     key={nodes.id}
  //     itemId={String(nodes.id)}
  //     label={
  //       <div style={{ display: 'flex', alignItems: 'center' }}>

  //         {/* <Checkbox
  //           checked={checked.indexOf(nodes.id) !== -1}
  //           onChange={handleToggle(nodes.id)}
  //           onClick={(event) => event.stopPropagation()}
  //         /> */}

  //         <div style={{ marginLeft: 8 }}>{nodes.locationObjectItem}</div>
  //       </div>
  //     }
  //   >
  //     {Array.isArray(nodes.childLocI)
  //       ? nodes.childLocI.map((node: any) => renderTrees(node))
  //       : null}
  //   </TreeItem>
  // );

  const renderTrees = (nodes: any) => (
    <TreeItem
      key={nodes.id}
      itemId={String(nodes.id)}
      label={
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* Include your Checkbox and other UI elements here */}
          <div style={{ marginLeft: 8 }}>{nodes.locationObjectItem}</div>
        </div>
      }
      // onExpand={handleNodeToggle(nodes.id)}
      // isExpanded={expandedNodes.includes(nodes.id) || nodes.locationObjectItem.toLowerCase().includes(filter.toLowerCase())}
    >
      {Array.isArray(nodes.childLocI) &&
        nodes.childLocI
          .filter((node: any) =>
            node.locationObjectItem.toLowerCase().includes(filter.toLowerCase())
          )
          .map((node: any) => renderTrees(node))}
    </TreeItem>
  );

  // const renderTree = (nodes:any) => (
  //     console.log("nodes.id",nodes.id),
  //     <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
  //         <FormControlLabel
  //           control={
  //             <Checkbox
  //               checked={checked.indexOf(nodes.id) !== -1}
  //               onChange={handleToggle(nodes.id)}
  //             />
  //           }
  //           label={nodes.locationObjectItem}
  //         />
  //       {Array.isArray(nodes.childLocI)
  //         ? nodes.childLocI.map((node:any) => renderTree(node))
  //         : null}
  //         </Box>
  //   );

  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [selectAll, setSelectAll] = useState<any>(false);

  console.log("slected option", selectedOptions);

  const handleSelectAll = () => {
    if (!selectAll) {
      setSelectedOptions(childOption);
    } else {
      setSelectedOptions([]);
    }
    setSelectAll(!selectAll);
  };

  return (
    <Container>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#FFFFFF",
          borderRadius: "5px",
          // border: ".5px solid #ff7722",
          marginTop: "3vh",
        }}
      >
        <ToastApp />
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500, marginTop: "10px" }}
          >
            {/* CREATE LOCATION ITEM */}
            {t("text.LocationItem")}
          </Typography>
          {/*<Grid xs={4} sm={12} item>
             <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: "blue",
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid> */}
          <Divider />
          <br />
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label= {t("text.LocationObjectItems")} {...a11yProps(0)} />
                <Tab label={t("text.Mapping")} {...a11yProps(1)} />
                {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
              </Tabs>
            </Box>

            <form onSubmit={formik.handleSubmit}>
              <CustomTabPanel value={value} index={0}>
                {toaster === false ? "" : <ToastApp />}
                <Grid item xs={12} container spacing={2}>
                  {/* <Grid xs={12} sm={2.5} item>
                    <input
                      type="text"
                      value={filter}
                      onChange={handleFilterChange}
                      placeholder="Search..."
                    />
                    <div style={{ height: "20vh", overflow: "auto" }}>
                      <SimpleTreeView>
                        
                        {Array.isArray(treedata)
                          ? treedata
                              .filter((node: any) =>
                                node.locationObjectItem
                                  .toLowerCase()
                                  .includes(filter.toLowerCase())
                              )
                              .map((node: any) => renderTrees(node))
                          : null}
                      </SimpleTreeView>
                    </div>
                  </Grid> */}

                  <Grid xs={12} sm={5} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={option}
                      fullWidth
                      size="small"
                      onChange={(
                        event: any,
                        newValue: { value: any } | null
                      ) => {
                        if (newValue == null) {
                          setParentId("");
                        } else {
                          console.log(newValue?.value);
                          setParentId(newValue?.value);
                          getChildlocationitem(newValue?.value);
                        }
                      }}
                      renderInput={(params: any) => (
                        <TextField
                          {...params}
                          label={
                            <span>
                              {t("text.selectParntLoc")}{" "}
                              {requiredFields.includes("parentId") && (
                                <span
                                  style={{
                                    color: formik.values.parentId
                                      ? "green"
                                      : "red",
                                  }}
                                >
                                  *
                                </span>
                              )}
                            </span>
                          }
                        />
                      )}
                    />
                    {formik.touched.parentId && formik.errors.parentId ? (
                      <div style={{ color: "red", margin: "5px" }}>
                        {formik.errors.parentId}
                      </div>
                    ) : null}
                  </Grid>

                  <Grid xs={12} sm={2.5} item>
                    <Autocomplete
                      disableCloseOnSelect
                      multiple
                      id="combo-box-demo"
                      options={childOption}
                      fullWidth
                      size="small"
                      onChange={(event, value) => setSelectedOptions(value)}
                      value={selectedOptions}
                      renderOption={(props, childOption, { selected }) => (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          <ListItemText primary={childOption.label} />
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <span>
                              {t("text.selectLoc")}{" "}
                              {requiredFields.includes("locationObjectId") && (
                                <span
                                  style={{
                                    color: formik.values.locationObjectId
                                      ? "green"
                                      : "red",
                                  }}
                                >
                                  *
                                </span>
                              )}
                            </span>
                          }
                        />
                      )}
                      ListboxComponent={(props) => (
                        <List {...props}>
                          {childOption && (
                            <ListItem button onClick={handleSelectAll}>
                              <ListItemIcon>
                                <Checkbox checked={selectAll} />
                              </ListItemIcon>
                              <ListItemText primary={t("text.selectAll")} />
                            </ListItem>
                          )}
                          {childOption.map((item: any) => (
                            <>
                              <ListItem key={item.value} button>
                                <ListItemIcon>
                                  <Checkbox
                                    checked={selectedOptions.some(
                                      (option: any) =>
                                        option.value === item.value
                                    )}
                                    onChange={() => {
                                      const selectedIndex =
                                        selectedOptions.findIndex(
                                          (option: any) =>
                                            option.value === item.value
                                        );
                                      let newSelected = [];

                                      if (selectedIndex === -1) {
                                        newSelected = [
                                          ...selectedOptions,
                                          item,
                                        ];
                                      } else {
                                        newSelected = [
                                          ...selectedOptions.slice(
                                            0,
                                            selectedIndex
                                          ),
                                          ...selectedOptions.slice(
                                            selectedIndex + 1
                                          ),
                                        ];
                                      }

                                      setSelectedOptions(newSelected);
                                      if (
                                        newSelected.length ===
                                        childOption?.length
                                      ) {
                                        setSelectAll(true);
                                      } else {
                                        setSelectAll(false);
                                      }
                                    }}
                                  />
                                </ListItemIcon>
                                <ListItemText primary={item.label} />
                              </ListItem>
                            </>
                          ))}
                        </List>
                      )}
                    />
                    {formik.touched.locationObjectId &&
                    formik.errors.locationObjectId ? (
                      <div style={{ color: "red", margin: "5px" }}>
                        {formik.errors.locationObjectId}
                      </div>
                    ) : null}
                  </Grid>

                  <Grid item lg={2.5} xs={12}>
                    <TextField
                      id="locationObjectItem"
                      name="locationObjectItem"
                      label={
                        <span>
                          {t("text.enterAddItem")}{" "}
                          {requiredFields.includes("locationObjectItem") && (
                            <span
                              style={{
                                color: formik.values.locationObjectItem
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                      value={formik.values.locationObjectItem}
                      placeholder={t("text.enterAddItem")}
                      size="small"
                      fullWidth
                      style={{
                        backgroundColor: "white",
                        borderColor:
                          formik.touched.locationObjectItem &&
                          formik.errors.locationObjectItem
                            ? "red"
                            : "initial",
                      }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.locationObjectItem &&
                    formik.errors.locationObjectItem ? (
                      <div style={{ color: "red", margin: "5px" }}>
                        {formik.errors.locationObjectItem}
                      </div>
                    ) : null}
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <Grid>
                      <Button
                        //type="submit"
                        // fullWidth
                        style={{
                          backgroundColor: "#059669",
                          color: "white",
                          marginTop: "2px",
                        }}
                        onClick={(e: any) => AddlocationItem()}
                      >
                        {selectedOptions?.length > 1 ? t("text.generate"): t("text.save")}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>

                <br />
                {/* <Divider>
                  <Chip label="Or" size="small" />
                </Divider>*/}
                <br /> 

                {selectedOptions?.length > 1 ? (
                  <Grid container xs={12} spacing={2}>
                    <Grid xs={12} sm={12} item>
                      <TableContainer sx={{ maxHeight: "35vh" }}>
                        <Table
                          style={{
                            borderCollapse: "collapse",
                            width: "100%",
                            border: "1px solid black",
                            // marginLeft: "20px",
                            // height:"400px"
                          }}
                        >
                          <thead
                            style={{
                              backgroundColor: "#2196f3",
                              color: "#f5f5f5",
                            }}
                          >
                            <tr>
                              <th
                                style={{
                                  borderLeft: "1px solid black",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                {t("text.LocationName")}
                              </th>
                              <th
                                style={{
                                  borderLeft: "1px solid black",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                {t("text.AliasName")}
                              </th>
                              <th
                                style={{
                                  borderLeft: "1px solid black",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                {t("text.From")}
                              </th>
                              <th
                                style={{
                                  borderLeft: "1px solid black",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                {t("text.To")}
                              </th>
                            </tr>
                          </thead>
                          <tbody style={{ border: "1px solid black" }}>
                            {selectedOptions.map(
                              (childOption: any, index: any) => (
                                <TableRow
                                  key={index}
                                  style={{ border: "1px solid black" }}
                                >
                                  <TableCell
                                    style={{
                                      borderLeft: "1px solid black",
                                      borderTop: "1px solid black",
                                      textAlign: "center",
                                    }}
                                  >
                                    {childOption?.label}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      borderLeft: "1px solid black",
                                      borderTop: "1px solid black",
                                      // textAlign: "center",
                                    }}
                                  >
                                    <TextField
                                      size="small"
                                      // fullWidth
                                      type="text"
                                      placeholder={t("text.EnterAliasName")}
                                      value={childOption.aliasName}
                                      style={{ width: "100%" }}
                                      onChange={(e) => {
                                        childOption.aliasName = e.target.value;
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      borderLeft: "1px solid black",
                                      borderTop: "1px solid black",
                                      // textAlign: "center",
                                    }}
                                  >
                                    <TextField
                                      size="small"
                                      // fullWidth
                                      type="text"
                                      placeholder={t("text.EnterFrom")}
                                      value={childOption.from}
                                      style={{ width: "100%" }}
                                      onChange={(e) => {
                                        childOption.from = e.target.value;
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      borderLeft: "1px solid black",
                                      borderTop: "1px solid black",
                                      // textAlign: "center",
                                    }}
                                  >
                                    <TextField
                                      size="small"
                                      // fullWidth
                                      type="text"
                                      placeholder={t("text.EnterTo")}
                                      value={childOption?.to}
                                      style={{ width: "100%" }}
                                      onChange={(e) => {
                                        childOption.to = e.target.value;
                                      }}
                                    />
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                          </tbody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid item xs={12} container spacing={2}>
                    <Grid item lg={3.3} xs={12}>
                      <TextField
                        id="locationAliasItem"
                        name="locationAliasItem"
                        label={<span>{t("text.enterAlias")} </span>}
                        value={formik.values.locationAliasItem}
                        placeholder={t("text.enterAlias")}
                        size="small"
                        fullWidth
                        // style={{
                        //   backgroundColor: "white",
                        //   borderColor:
                        //     formik.touched.locationAliasItem &&
                        //     formik.errors.locationAliasItem
                        //       ? "red"
                        //       : "initial",
                        // }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {/* {formik.touched.locationAliasItem &&
                      formik.errors.locationAliasItem ? (
                        <div style={{ color: "red", margin: "5px" }}>
                          {formik.errors.locationAliasItem}
                        </div>
                      ) : null} */}
                    </Grid>
                    <Grid item lg={3.3} xs={12}>
                      <TextField
                        id="fromNo"
                        name="fromNo"
                        label={
                          <span>
                            {t("text.enterFrom")}{" "}
                            {requiredFields.includes("fromNo") && (
                              <span
                                style={{
                                  color: formik.values.fromNo ? "green" : "red",
                                }}
                              >
                                *
                              </span>
                            )}
                          </span>
                        }
                        value={formik.values.fromNo}
                        placeholder={t("text.enterFrom")}
                        size="small"
                        fullWidth
                        style={{
                          backgroundColor: "white",
                          borderColor:
                            formik.touched.fromNo && formik.errors.fromNo
                              ? "red"
                              : "initial",
                        }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.fromNo && formik.errors.fromNo ? (
                        <div style={{ color: "red", margin: "5px" }}>
                          {formik.errors.fromNo}
                        </div>
                      ) : null}
                    </Grid>
                    <Grid item lg={3.3} xs={12}>
                      <TextField
                        id="toNo"
                        name="toNo"
                        label={
                          <span>
                            {t("text.enterTo")}{" "}
                            {requiredFields.includes("toNo") && (
                              <span
                                style={{
                                  color: formik.values.toNo ? "green" : "red",
                                }}
                              >
                                *
                              </span>
                            )}
                          </span>
                        }
                        value={formik.values.toNo}
                        placeholder={t("text.enterTo")}
                        size="small"
                        fullWidth
                        style={{
                          backgroundColor: "white",
                          borderColor:
                            formik.touched.toNo && formik.errors.toNo
                              ? "red"
                              : "initial",
                        }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.toNo && formik.errors.toNo ? (
                        <div style={{ color: "red", margin: "5px" }}>
                          {formik.errors.toNo}
                        </div>
                      ) : null}
                    </Grid>
                    <Grid item lg={2} xs={12}>
                      <Grid>
                        <Button
                          // type="submit"
                          // fullWidth
                          style={{
                            backgroundColor: "#1F75FE",
                            color: "white",
                            marginTop: "2px",
                          }}
                          onClick={(e: any) => AddlocationItem()}
                        >
                          {t("text.generate")}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </CustomTabPanel>

              <CustomTabPanel value={value} index={1}>
                <Grid container spacing={2}>
                  <Grid item sm={6}>
                    <Typography
                      variant="h5"
                      textAlign="center"
                      style={{
                        fontSize: "18px",
                        fontWeight: 500,
                        marginTop: "10px",
                      }}
                    >
                      {t("text.LocationItem")}
                      {/* {t("text.LocationItem")} */}
                    </Typography>
                    <Divider></Divider>
                    <Grid item sm={12}>
                      <Box>
                        <div style={{ height: "300px", overflow: "auto" }}>
                          <SimpleTreeView
                          // defaultCollapseIcon={<ExpandMoreIcon />}
                          //defaultExpandIcon={<ChevronRightIcon />}
                          // multiSelect={true}
                          //<div style={{ height: '300px', overflow: 'auto' }}>
                          >
                            {Array.isArray(treedata)
                              ? treedata.map((node: any) => renderTree(node))
                              : null}
                          </SimpleTreeView>
                        </div>
                      </Box>
                      <Grid container spacing={5}>
                        <Grid item lg={4} sm={4} xs={6}>
                          <Button
                            //type="reset"
                            fullWidth
                            style={{
                              backgroundColor: "#37d67a",
                              color: "white",
                              marginTop: "10px",
                              // marginLeft:"50px",
                            }}
                            onClick={(e: any) => {
                              Addmappedlocation();
                            }}
                          >
                            {EditId > 0 ? t("text.UpdateMapped") :  t("text.Mapped")}
                          </Button>
                        </Grid>
                        <Grid item lg={4} sm={4} xs={6}>
                          <Button
                            //  type="reset"
                            fullWidth
                            style={{
                              backgroundColor: "#F43F5E",
                              color: "white",
                              marginTop: "10px",
                              // marginLeft:"50px",
                            }}
                            onClick={(e: any) => {
                              UnmappedlocationItem();
                            }}
                          >
                             {t("text.Unmapped")}
                          </Button>
                        </Grid>
                        <Grid item lg={4} sm={4} xs={6}>
                          <Button
                            // type="reset"
                            fullWidth
                            style={{
                              backgroundColor: "#2ccce4",
                              color: "white",
                              marginTop: "10px",
                              // marginLeft:"50px",
                            }}
                            onClick={(e: any) => {
                              setChecked([]);
                              setEditId(-1);
                            }}
                          >
                             {t("text.reset")}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item sm={6}>
                    <Typography
                      variant="h5"
                      textAlign="center"
                      style={{
                        fontSize: "18px",
                        fontWeight: 500,
                        marginTop: "10px",
                      }}
                    >
                       {t("text.MappedLocation")}
                      {/* {t("text.LocationItem")} */}
                    </Typography>
                    <Divider></Divider>
                    <Grid item sm={12}>
                      <div
                        style={{ width: "100%", backgroundColor: "#FFFFFF" }}
                      >
                        <DataGrid
                          rows={tabledata}
                          columns={adjustedColumns}
                          autoHeight
                          slots={{
                            toolbar: GridToolbar,
                          }}
                          rowSpacingType="border"
                          pagination={true}
                          pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                            value: size,
                            label: `${size}`,
                          }))}
                          initialState={{
                            pagination: { paginationModel: { pageSize: 5 } },
                          }}
                          slotProps={{
                            toolbar: {
                              showQuickFilter: true,
                            },
                          }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </CustomTabPanel>
            </form>
          </Box>
        </CardContent>
      </div>
    </Container>
  );
}
